/*@ngInject*/
const AdminFunctionHeaderButtonsModel = function (adminFunctionConstants, userType, organizationType) {
    this.tabList=[];
    this.navigationMappings = {};
    this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB] = {};
    this.navigationMappings[adminFunctionConstants.USERS_TAB] = {};
    this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB] = {};
    this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB] = {};
    this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB] = {};
    this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB] = {};

    this.setupStateMappings = function () {
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_FORMS] = {
            state: 'configuration.formTemplateBrowser',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_DATA_SETS] = {
            state: 'configuration.dataSetBrowser',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_RULES] = {
            state: 'configuration.rulesBrowser'
        };
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_PRODUCTS] = {
            state: 'configuration.productTemplateBrowser',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_SECTIONS] = {
            state: 'configuration.sectionTemplateBrowser',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_SCORING_RULES] = {
            state: 'configuration.scoringRulesBrowser',
            params: {}
        };

        this.navigationMappings[adminFunctionConstants.CONFIGURATION_TAB][adminFunctionConstants.CONFIGURATION_RATE_STATUS] = {
            state: 'configuration.rateStatus',
            params: {}
        };

        this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_AGENCY_BROKERAGE_USERS] = {
            state: 'userList',
            params: {userType: userType.AGENCY_BROKERAGE}
        };
        this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_UNDERWRITERS] = {
            state: 'userList',
            params: {userType: userType.UNDERWRITER}
        };
        this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.SERVICE_TEAM_USERS] = {
            state: 'userList',
            params: {userType: userType.SERVICE}
        };
        this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.SYSTEM_USERS] = {
            state: 'userList',
            params: {userType: userType.SYSTEM}
        };
        this.navigationMappings[adminFunctionConstants.USERS_TAB][adminFunctionConstants.USERS_USER_GROUPS] = {
            state: 'userGroups',
            params: {userType: userType.USERS_USER_GROUPS}
        };
        this.navigationMappings[adminFunctionConstants.USERS_TAB]['userSubTab'] = {
            state: 'manageUser.form'
        };

        this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_AGENCY_BROKERAGE] = {
            state: 'configuration.organizationBrowser',
            params: {organizationType: organizationType.AGENCY}
        };
        this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_MGA_AGENCY_BROKERAGE] = {
            state: 'configuration.organizationBrowser',
            params: {organizationType: organizationType.MGA_AGENCY}
        };
        this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_CARRIER_ORGANIZATION] = {
            state: 'configuration.organizationBrowser',
            params: {organizationType: organizationType.CARRIER}
        };
        this.navigationMappings[adminFunctionConstants.ORGANIZATIONS_TAB][adminFunctionConstants.ORGANIZATIONS_MGA_ORGANIZATION] = {
            state: 'configuration.organizationBrowser',
            params: {organizationType: organizationType.MGA_CARRIER}
        };

        this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_AGENCY_BROKERAGE] = {
            state: 'configuration.permissionsEditor',
            params: {userType: userType.AGENCY_BROKERAGE}
        };
        this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_SERVICE_TEAM] = {
            state: 'configuration.permissionsEditor',
            params: {userType: userType.SERVICE}
        };
        this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_SYSTEM] = {
            state: 'configuration.permissionsEditor',
            params: {userType: userType.SYSTEM}
        };
        this.navigationMappings[adminFunctionConstants.PERMISSIONS_TAB][adminFunctionConstants.PERMISSIONS_UNDERWRITING] = {
            state: 'configuration.permissionsEditor',
            params: {userType: userType.UNDERWRITER}
        };

        this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB][adminFunctionConstants.NOTIFICATIONS_EMAIL] = {
            state: 'configuration.emailBrowser',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.NOTIFICATIONS_TAB][adminFunctionConstants.NOTIFICATIONS_POP_UP] = {
            state: 'configuration.popupBrowser',
            params: {}
        };

        this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB][adminFunctionConstants.PREFERENCES_GENERAL] = {
            state: 'configuration.systemPreferencesManager',
            params: {}
        };
        this.navigationMappings[adminFunctionConstants.PREFERENCES_TAB][adminFunctionConstants.PREFERENCES_FILES_AND_ICONS] = {
            state: 'configuration.filesAndIconsManager',
            params: {}
        };
    };

    this.getStateMappings = function (name,subTab){
        return this.navigationMappings[name][subTab];
    };

    this.setupStateMappings ();

};

angular.module('gw-um-header')
    .service('adminFunctionHeaderButtonsModel', AdminFunctionHeaderButtonsModel);
